<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle"><a id="h1">CONTENTS</a></h2><a id="h1">
</a><p class="toc"><a id="h1"></a><a href="#/06_part01#h2">PART ONE</a></p>
<p class="toc"><span href="#/07_part02#h3" title="Link target outside of Sample">PART TWO</span></p>
<p class="toc"><span href="#/08_part03#h4" title="Link target outside of Sample">PART THREE</span></p>
<p class="toc"><span href="#/09_part04#h5" title="Link target outside of Sample">PART FOUR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?e6b7cfdc